"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithdrawalIsCheck = function (_a) {
    var onClose = _a.onClose, onSubmit = _a.onSubmit, amount = _a.amount, children = _a.children, methodName = _a.methodName;
    var t = (0, next_intl_1.useTranslations)('translation');
    var date = (0, date_fns_1.format)(new Date(), 'dd-LL-yy HH:mm:ss');
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "335px", height: "490px", portalNodeId: "modal", onClose: onClose, showClose: true, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                        __html: t.raw('withdrawalRequestCheck'),
                    } }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.text, dangerouslySetInnerHTML: {
                        __html: t.raw('withdrawalRequestCheckText'),
                    } }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.amount }, amount),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.amountText, dangerouslySetInnerHTML: {
                            __html: t.raw('withdrawalRequestCheckAmount'),
                        } })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.values },
                    children,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.date }, date)),
                methodName === 'crypto-currency' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                    react_1.default.createElement("p", null, t('withdrawalRequestCheckCryptoInfo')),
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null, t('withdrawalRequestCheckCryptoInfoLi1')),
                        react_1.default.createElement("li", null, t('withdrawalRequestCheckCryptoInfoLi2'))),
                    react_1.default.createElement("p", null, t('withdrawalRequestCheckCryptoInfo2'))))),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "46px", onClick: function () {
                    onSubmit();
                    onClose();
                }, maxWidth: "100%" }, t('submit')))));
};
exports.default = WithdrawalIsCheck;
